import {nextTick} from 'vue'

export type CrTransGridElement = {
    rowIndex: number,
    columnIndex: number,
    columnId: string
}

const findInputElementRecursively = (element: HTMLElement): HTMLElement | null => {
    if (element.tagName === 'INPUT') {
        return element
    }
    if (element.children.length > 0) {
        for (let i = 0; i < element.children.length; i++) {
            const child = element.children[i]
            const inputElement = findInputElementRecursively(child as HTMLElement)
            if (inputElement) {
                return inputElement
            }
        }
    }
    return null
}

export const focusNext = () => {
    const activeGridElement = findGridElementFromActiveElement()
    if (!activeGridElement) return

    const rowIndex = activeGridElement.getAttribute('data-row-index')
    const colIndex = activeGridElement.getAttribute('data-col-index')

    if (rowIndex === null || colIndex === null) return

    focusGridElement(parseInt(rowIndex), parseInt(colIndex) + 1)
}


export const focusGridElement = (rowIndex: number, colIndex: number, direction?: string) => {
    focusElementRecursive(rowIndex, colIndex, direction)
}

const focusElementRecursive = (rowIndex: number, colIndex: number, direction?: string) => {
    nextTick(() => {
        const element = document.querySelector(
            `.cr-tr-grid-element[data-row-index="${rowIndex}"][data-col-index="${colIndex}"]`
        )
        if (!element) {
            console.warn(`Element not found for rowIndex: ${rowIndex}, colIndex: ${colIndex}`)
            return
        }

        const inputElement = findInputElementRecursively(element as HTMLElement)

        if (inputElement?.hasAttribute('disabled') || inputElement?.getAttribute('aria-disabled') === 'true') {
            if (direction === 'left') {
                focusElementRecursive(rowIndex, colIndex - 1, direction)
            } else {
                focusElementRecursive(rowIndex, colIndex + 1, direction)
            }
        } else {
            inputElement?.focus()
        }
    })
}

const findGridElementFromActiveElement = () => {
    const activeElement = document.activeElement
    if (!activeElement) {
        return null
    }
    return findFirstParentWithClass(activeElement as HTMLElement, 'cr-tr-grid-element')
}

const findFirstParentWithClass = (element: HTMLElement, className: string): HTMLElement | null => {
    if (element.classList.contains(className)) {
        return element
    }
    if (element.parentElement) {
        return findFirstParentWithClass(element.parentElement as HTMLElement, className)
    }
    return null
}

export const focusElementByIndex = (rowIndex: number, columnIndex: number) => {
    const element = document.querySelector(`.cr-tr-grid-element[data-row-index="${rowIndex}"][data-col-index="${columnIndex}"]`)
    const inputElement = element && findInputElementRecursively(element as HTMLElement)
    inputElement?.focus()
}


export const focusElementByColumnId = (rowIndex: number, columnId: string) => {
    const element = document.querySelector(`.cr-tr-grid-element[data-row-index="${rowIndex}"][data-col-id="${columnId}"]`)
    const inputElement = element && findInputElementRecursively(element as HTMLElement)
    inputElement?.focus()
}

export const getColumnIndexFromColumnId = (columnId: string) => {
    const firstRowElements = Array.from(
        document.querySelectorAll('.cr-tr-grid-element[data-row-index="0"]')
    )
    return firstRowElements.findIndex(
        el => el.getAttribute('data-col-id') === columnId
    )
}
